import React from 'react'
import CartIcon from './icons/cart'
import { useContext } from 'react'
import { AppConfigContext } from '../../../../context/AppConfig'

function CortFormButton({ className = '', onClick }) {
  const { isSWApp, isEWApp, isPDApp } = useContext(AppConfigContext)

  function getText() {
    if (isEWApp) {
      return 'Customize and Checkout'
    }
    if (isSWApp) {
      return 'Connect with Furniture Vendor'
    }
    if (isPDApp) {
      return 'Contact Property to Rent a Package'
    }
    return 'Contact CORT to Rent a Package'
  }

  return (
    <button type="button" onClick={onClick} className={`${className} flex items-center `}>
     
      <div className={`bg-[var(--brand-color)] ${isPDApp ? '!bg-black' : ''} rounded-l-[4px] px-[10px] pr-[20px] h-[32px] flex items-center text-[14px] text-white font-medium`}>
        {getText()}
      </div>
      <div className="bg-white h-[40px] aspect-square rounded-full flex items-center justify-center ml-[-12px]">
        <CartIcon stroke={isPDApp ? 'black' : undefined} />
      </div>
    </button>
  )
}

export default CortFormButton
